App.factory('branchService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function BranchService() {
        this.dataBranchLists = function() {
            return baseService.getWithOutAuth(Config.API_URL + '/company/' + Config.COMPANY_ID + '/branch/list').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.dataZochBranchLists = function() {
            return baseService.post(Config.API_URL + '/zocha/branch/attached').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getZochaAllowedBranchesForReports = function() {
            return baseService.get(Config.API_URL + '/zocha/branch/forReports').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getZochaAllowedBranchesForDeclarations = function() {
            return baseService.get(Config.API_URL + '/zocha/branch/forDeclarations').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
    }
    return new BranchService();
}]);